module.exports = __webpack_public_path__ + "static/media/29BDOS1.b18295e3.jpg";